import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

const SevenCards = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user ? user.role : null;
  return (
    <div className="row mx-lg-n4 ">
      {userRole && userRole === "1" ? (
        <>
          <div className="col-lg-3 col-md-6 px-lg-4">
            <Link to="/pending_orders" className="text-decoration-none">
              <div className="card shadow">
                <div className="p-3 d-flex justify-content-center">
                  <div className="text-center">
                    <span className="h6 text-primary">Commande En Attente</span> <span className="text-primary">-&gt;</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-lg-3 col-md-6 px-lg-4">
            <Link to="/orders_in_progress" className="text-decoration-none">
              <div className="card shadow">
                <div className="p-3 d-flex justify-content-center">
                  <div className="text-center">
                    <span className="h6 text-primary">Commande En Cours</span> <span className="text-primary">-&gt;</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-lg-3 col-md-6 px-lg-4">
            <Link to="/orders_delivered" className="text-decoration-none">
              <div className="card shadow">
                <div className="p-3 d-flex justify-content-center">
                  <div className="text-center">
                    <span className="h6 text-primary">Commande Livrée</span> <span className="text-primary">-&gt;</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-lg-3 col-md-6 px-lg-4">
            <Link to="/orders_cancelled" className="text-decoration-none">
              <div className="card shadow">
                <div className="p-3 d-flex justify-content-center">
                  <div className="text-center">
                    <span className="h6 text-primary">Commande Annulée</span> <span className="text-primary">-&gt;</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Concernant la deuxieme ligne */}

          <div className="col-lg-6 col-md-6 px-lg-4">
            <div className="card shadow">
              <Link to="/about" className="text-decoration-none">
                <div className="p-3 d-flex justify-content-center">
                  <div>
                    <span className="h6">A Propos</span> <span>-&gt;</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 px-lg-4">
            <div className="card shadow">
              <Link to="/contact_support" className="text-decoration-none">
                <div className="p-3 d-flex justify-content-center">
                  <div>
                    <div className="icon icon-shape rounded-circle bg-success text-white mr-4"></div>
                  </div>
                  <div>
                    <span className="h6">Contacter Support</span><span>-&gt;</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>

        

          <div className="col-lg-4 col-md-6 px-lg-4"></div>
        </>
      ) : (
        <>
          {/* Concernant la deuxieme ligne */}

          <div className="col-lg-6 col-md-6 px-lg-4">
            <div className="card shadow-none hover-shadow-lg overflow-hidden">
              <Link to="/about" className="text-decoration-none">
                <div className="p-3 d-flex justify-content-center">
                  <div>
                    <span className="">A Propos</span><span>-&gt;</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 px-lg-4">
            <div className="card shadow-none hover-shadow-lg overflow-hidden">
              <Link to="/contact_support" className="text-decoration-none">
                <div className="p-3 d-flex justify-content-center">
                  <div>
                    <div className="icon icon-shape rounded-circle bg-success text-white mr-4"></div>
                  </div>
                  <div>
                    <span className="h6">Contacter Support</span><span>-&gt;</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 px-lg-4"></div>
        </>
      )}
    </div>
  );
};

export default SevenCards;
